import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { NewTrans, useNewTranslation } from 'hooks'

import { closeModal, GLOBAL_MODAL_TYPE, selectIsModalOpen } from 'state/constants'
import Modal from 'particles/Modal'
import Text from 'particles/Text'

interface ExportModalProps {
    title?: string
    DescriptionComponent?: React.ReactNode
    tableTitle?: string
    isRequesting: boolean
    onClickExport: () => void
}

const ExportModal: React.FC<ExportModalProps> = ({
    tableTitle,
    isRequesting,
    onClickExport,
    title,
    DescriptionComponent,
}) => {
    const [t] = useNewTranslation()
    const dispatch = useDispatch()
    const isModalOpen = useSelector(selectIsModalOpen(GLOBAL_MODAL_TYPE.REQUEST_EXPORT))

    const onCloseModal = useCallback(() => dispatch(closeModal()), [])

    return (
        <>
            {isModalOpen && (
                <Modal
                    title={
                        title
                            ? title
                            : t('modalWindow.exportTableTitle', {
                                  tableTitle,
                              })
                    }
                    secondaryButtonProps={{
                        label: t('button.cancel'),
                        isDisabled: isRequesting,
                    }}
                    primaryButtonProps={{
                        label: t('button.export'),
                        isDisabled: isRequesting,
                    }}
                    size="m"
                    hasIcon={false}
                    onConfirm={onClickExport}
                    onClose={onCloseModal}
                >
                    {DescriptionComponent ? (
                        DescriptionComponent
                    ) : (
                        <NewTrans i18nKey="modalWindow.exportTableSubtitle">
                            <Text scale="bodyM400">
                                You’re requesting to export the {{ tableTitle }} data for this campaign.
                            </Text>
                            <Text scale="bodyM400">
                                It might take a few minutes for the file to be generated. Once this process is complete,
                                the exported file will be sent to the email address associated with your current CM
                                account.
                            </Text>
                        </NewTrans>
                    )}
                </Modal>
            )}
        </>
    )
}

export default ExportModal
